import Icon from '../components/Icon.vue'

Icon.register({
  'dice-d6': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M422.2 109.9c5.3 3.2 5.3 11.3-0.1 14.5l-198.1 118.1-198.1-118.1c-5.4-3.2-5.4-11.2-0.1-14.5l166-100.9c19.9-12.1 44.5-12.1 64.4 0zM436 154.6c5.3-3.2 12 0.8 12 7.3v197.7c0 23.8-12.1 45.7-31.8 57.7l-152.2 92.5c-10.7 6.5-24-1.5-24-14.4v-223.8zM0 161.8c0-6.4 6.6-10.4 12-7.3l196 116.9v223.8c0 12.9-13.4 20.9-24 14.4l-152.2-92.5c-19.7-12-31.8-33.9-31.8-57.7v-197.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/dice-d6.js
// module id = 1262
// module chunks = 0